import { format, formatDistanceToNow } from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date) {
  return date ? format(new Date(date), "MM/dd/yyyy") : "";
}

export function fDateDoc(date) {
  return date ? format(new Date(date), "yyyy-MM-dd") : "";
}

export function fDate1(date) {
  return date ? format(new Date(date), "yyyy/MM/dd") : null;
}
export function exportDate(date) {
  return format(new Date(date), "MM-dd-yyyy_HHmmss");
}

export function fDateTime(date) {
  return date ? format(new Date(date), "MMM-dd-yyyy HH:mm") : null;
}

export function fDateTimeSuffix(date) {
  return date ? format(new Date(date), "dd/MM/yyyy hh:mm a") : null;
}
export function formatDateTimeAMPM(date) {
  return date ? format(new Date(date), "MM/dd/yyyy hh:mm a") : null;
}

export function formatDateTimeAMPMWith24(date) {
  return date ? format(new Date(date), "MM/dd/yyyy HH:mm a") : null;
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : null;
}
export function fDate12(date) {
  return date ? format(new Date(date), "MMM-dd-yyyy  p") : null;
}

export function getCurrentDate() {
  return format(new Date(), "MM/dd/yyyy");
}
export function getCurrentTime() {
  return format(new Date(), "hh:mm:ss");
}

export function MinDate() {
  return new Date("01/01/1900");
}

export function Today() {
  return new Date(); // returns current date as a Date object
}
export function getYear() {
  return new Date()?.getFullYear(); // returns current date as a Date object
}
